import React from 'react'
import { Icon } from '@material-ui/core'
import WarningReplacedIconSvg from '../../../../assets/svg/warning-replaced-icon.svg'

export function WarningReplacedIcon({ size, ...restProps }) {
    return (
        <Icon {...restProps}>
            <img src={WarningReplacedIconSvg} width={size} height={size} />
        </Icon>
    )
}
